module.exports = __webpack_public_path__ + "static/media/White Bread.0dc8052a.jpg";